import { render, staticRenderFns } from "./PrintSalonContract.vue?vue&type=template&id=207d83a9&"
import script from "./PrintSalonContract.vue?vue&type=script&lang=js&"
export * from "./PrintSalonContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports